import Localization from "../localization";
import { Modal } from "../components";
import { App } from "antd";

const useApp = () => {
  const app = App.useApp();

  const success = ({
    onOk,
    title,
    afterClose = () => {},
    okText = Localization.general.ok.toUpperCase(),
    ...props
  } = {}) => {
    const modal = app.modal.success({
      afterClose,
      width: "52.3rem",
      maskClosable: true,
      onCancel: () => modal.destroy(),
      style: { top: "4.5rem", pointerEvents: "auto" },
      modalRender: () => (
        <Modal.Card title={title} closeable close={() => modal.destroy()}>
          <Modal.Dialog
            {...props}
            buttons={[
              {
                type: "primary",
                title: okText,
                onClick: () => (!!onOk ? onOk(modal) : modal.destroy()),
              },
            ]}
          />
        </Modal.Card>
      ),
    });
    return modal;
  };

  const confirm = ({
    onOk,
    title,
    cancelText = Localization.general.cancel,
    okText = Localization.general.ok.toUpperCase(),
    ...props
  } = {}) => {
    const modal = app.modal.confirm({
      maskClosable: true,
      width: "52.3rem",
      onCancel: () => modal.destroy(),
      style: { top: "4.5rem", pointerEvents: "auto" },
      modalRender: () => (
        <Modal.Card title={title} closeable close={() => modal.destroy()}>
          <Modal.Dialog
            {...props}
            buttons={[
              {
                type: "primary",
                title: okText,
                onClick: () => (!!onOk ? onOk(modal) : modal.destroy()),
              },
              {
                onClick: () => modal.destroy(),
                title: cancelText,
              },
            ]}
          />
        </Modal.Card>
      ),
    });
    return modal;
  };

  return {
    ...app,
    modal: { ...app.modal, success, confirm },
  };
};

export default useApp;
